<template>
    <div class="post-drawer" @click.self="close">
      
        <div class="drawer">
            <!-- <img src="./Group_169.png" style="height: 100vh;position: absolute;left: 0;transform: translateX(-100%);"> -->
            <div class="drawer-header">
                <div class="container-title">
                    <p class="title">Aperçu</p>

                 

                    <div class="badge-status" :status="event.status" :class="event.status">
                        {{ $t(`dash.post.${event.status}`)}}

                        <template v-if="!['awaiting_approval','to_validate'].includes(event.status)">
                        • {{ new Date(event.date).toLocaleDateString('fr-FR',{ weekday: 'long', day: 'numeric', month: 'short' }) }}
                        </template>
                    </div>

                
                 
                </div>
                <div class="close">
                   
                    <ContextMenu :options="[{label: 'Copier le lien d\'accès rapide', name : 'copyLink'}]" :id="'drawerMoreOption'" v-on:clickOption="clickOption">
                        <i class="fa-solid fa-ellipsis-vertical more"></i>
                    </ContextMenu>

                    <i class="fa-solid fa-xmark-large"  @click="close"></i>
                </div>
            </div>
            <div class="drawer-render" :class="event.draft.tab" @mouseenter="expandedSectionNav = false">
                <div class="container-phone">
                    <div class="actions" v-if="!currentUser.role || currentUser.role.length !== 1 || currentUser.role[0] !== 'Viewer'">
                        <i class="fa-solid fa-pencil" v-if="['scheduled', 'draft'].includes(this.officialStatus)" @click="editPost"></i>
                        <i class="fa-solid fa-clone" @click="duplicatePost"></i>
                        <i class="fa-solid fa-trash-can" @click="()=>deletePost()"></i>
                    </div>
                    <Phone :showNotch="event.draft.tab == 'standard'" @click="()=>indexStorySelected = (indexStorySelected+1)%Object.keys(formData.storification).length">
                       
                        <template v-if="formData && Object.keys(formData).length">
                            <div v-if="event.draft.tab && event.draft.tab !== 'standard'" class="drawer-container-storyMaker">
                                <div class="nav-story" v-if="Object.keys(formData.storification).length > 1">
                                     <div class="bar" v-for="(key, index) in Object.keys(formData.storification)" :class="{active: indexStorySelected == index}"></div>
                                </div>

                                <StoryMaker
                                    :formData="formData"
                                    :idStorySelected="Object.keys(formData.storification)[indexStorySelected]"
                                    :pageSelected="allPages[event.page.id]"
                                    :previewEnabled="true"
                                    :files="event.draft.files"
                                />
                            </div>
                            <RenderPostManager 
                                v-else
                                :typeNetworkSelected="event.page.network"
                                :formData="formData"
                                :files="event.draft.files"
                                :pages="[allPages[event.page.id]]"
                            /> 
                        </template>                  
                    </Phone>
                </div>
              
            </div>
            <div class="drawer-container-navigation" ref="scrollContainer">
                <div class="drawer-navigation" :class="{expanded: expandedSectionNav}">
                    <div class="tab" @click="expandedSectionNav = !expandedSectionNav">
                        <i class="fa-solid" :class="expandedSectionNav ? 'fa-caret-down' : 'fa-caret-up'"></i>
                        <!-- <svg width="100%" height="100%" viewBox="0 0 88 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.0883 0C8.04076 0 3.64095 3.43527 2.41674 8.33211L0.41674 16.3321C0.277115 16.8906 0.182703 17.4477 0.130859 18H85.5379C85.5021 17.6164 85.4458 17.2303 85.3683 16.8427L83.7683 8.84272C82.74 3.70106 78.2254 0 72.9819 0H13.0883Z" fill="white"/>
                        </svg> -->
                        <svg  width="100%" height="100%" viewBox="0 0 89 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.0872 2C10.0401 2 5.64066 5.43527 4.41655 10.3321L2.41672 18.3321C2.2771 18.8906 2.1827 19.4477 2.13086 20H87.5309C87.495 19.6164 87.4388 19.2303 87.3613 18.8427L85.7614 10.8427C84.7332 5.70106 80.219 2 74.9759 2H15.0872Z" fill="white"/>
                        </svg>

                    </div>
  
                    <div class="navigation">
                         <div v-if="validationStatus !== null" class="item" @click="sectionNavSelected = 'validation'" :class="{active: sectionNavSelected == 'validation'}">Validation</div>
                        <div class="item" @click="sectionNavSelected = 'comments'" :class="{active: sectionNavSelected == 'comments'}">Notes</div>
                        <div class="item" @click="sectionNavSelected = 'assignments'" :class="{active: sectionNavSelected == 'assignments'}">Assignation</div>
                        <!-- <div class="item" @click="sectionNavSelected = 'logs'" :class="{active: sectionNavSelected == 'logs'}">Historique</div> -->
                    </div>
                    <div v-if="sectionNavSelected == 'validation'" class="list-assignment hide-scrollbar" :class="{ 'no-scroll': !expandedSectionNav }">
                      
                        <div v-if="validationStatus" class="btn-primary" @click="()=>removeValidationPost()" :class="{loading: loading.validation}">
                            <p>Annuler la validation du post</p>
                        </div>
                         <div v-else class="btn-primary" @click="()=>validatePost()" :class="{loading: loading.validation}">
                            <p>Valider le post pour publication</p>
                        </div>
                    </div>
                    <div v-else-if="sectionNavSelected == 'comments'" class="list-notes hide-scrollbar" :class="{ 'no-scroll': !expandedSectionNav }">
                        <div class="item input mediaMultiple">
                            <div class="container-text">
                                <div class="left">
                                    <div class="author">
                                    <div class="author-picture">
                                        <img :src="currentUser.avatar || 'img/avatar.jpg'"/>
                                    </div> 
                                    <div class="author-tect-info">
                                            <p class="name">Vous</p>
                                            <p class="date">A l'instant</p>
                                    </div>
                                    </div>
                                    <textarea
                                        v-model="models.commentValue"
                                        ref="textarea"
                                        rows="1"
                                        @focus="resize"
                                        @keyup="resize"
                                        placeholder="Ecrivez une note..."
                                    ></textarea>
                                </div>
                                <div class="right">
                                    <div class="container-add-media">
                                        <label for="fileComment">
                                            <i class="fa-regular fa-paperclip"></i>
                                        </label>
                                        <input
                                            v-validate="''"
                                            name="fileComment"
                                            type="file"
                                            id="fileComment"
                                            ref="inputMediaComment"
                                            @change="selectFilesComment"
                                            :multiple="true"
                                            @click="()=>{}"
                                            :accept="'.jpg, .jpeg, .png, .pdf, .mp4, .webm, .ogg, .avi, .wmv, .flv, .mkv'" 
                                            hidden
                                        > 

                                    </div>
                                </div>
                            </div>
                            <div class="container-media" v-if="filesUploadComment.length">
                                <template v-for="(file, index) in filesUploadComment">
                                    <div class="image" v-if="file.type.startsWith('image')" @click="$delete(filesUploadComment,index)">
                                        <img :src="file.url"/>
                                    </div>
                                    <div class="video" v-else-if="file.type.startsWith('video')" @click="$delete(filesUploadComment,index)">
                                        <video muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true">
                                            <source :src="file.url" :type="file.type">
                                        </video>
                                    </div>
                                </template>
                            </div>
                            <div v-if="models.commentValue.length || filesUploadComment.length" class="send" :class="{loading: this.loading.sendComment}" @click="()=>newComment()"><p>Envoyer</p></div>
                         
                        </div>

                        <div class="item" v-for="comment in comments" :class="{mediaMultiple: comment.mediasUpload.length > 1}">
                            <div class="container-text">
                                <div class="author">
                                    <div class="author-picture">
                                        <img :src="comment.avatar || 'img/avatar.jpg'"/>
                                    </div> 
                                    <div class="author-tect-info">
                                        <p class="name">{{ comment.name }}</p>
                                        <p class="date">{{ comment.dateFormat }}</p>
                                    </div>
                                </div>
                                <p class="text">{{ comment.message }}</p>
                            </div>
                            <div class="container-media">
                                <template v-for="media in comment.mediasUpload">
                                    <div class="image" v-if="media.type.startsWith('image')">
                                        <img :src="media.url"/>
                                    </div>
                                    <div class="video" v-else-if="media.type.startsWith('video')" >
                                        <video muted loop playsinline preload="metadata" class="source" onloadedmetadata="this.muted = true">
                                            <source :src="media.url" :type="media.type">
                                        </video>
                                    </div>
                                   
                                  
                                </template>
                              
                            </div>
                        </div>
                    </div>
                    <div v-else-if="sectionNavSelected == 'assignments'" class="list-assignment hide-scrollbar" :class="{ 'no-scroll': !expandedSectionNav }">
                        <div class="item" v-for="user in userAffected">
                            <div class="picture">
                                <img :src="user.avatar ? user.avatar : 'img/avatar.jpg'"/>
                            </div>
                            <div class="info-text">
                                <div class="container-name">
                                    <p class="name">{{ user.firstname }} {{ user.lastname }}</p>
                                    <p class="role">{{ user.admin == true ? 'Admin'+' ' : user.role && user.role.length > 0 ? $t(`dash.settings.user.${user.role[0]}`) : $t("dash.settings.user.Editor")+' '}}</p>
                                </div>
                                <p class="email">{{ user.email }}</p>
                            </div>
                            <div class="remove" @click="removeUserAffected(user.id)">
                                <i class="fa-solid fa-xmark-large"></i>
                            </div>
                        </div>
                        <div class="btn-primary" @click="setUsersAffected" :class="{loading: loading.setUserAffected}">
                            <p>Assigner</p>
                        </div>
                    </div>
                    <div v-else-if="sectionNavSelected == 'logs'" class="list-logs hide-scrollbar" :class="{ 'no-scroll': !expandedSectionNav }">
                        <div class="item">
                            <div class="picture">
                                <img src="https://picsum.photos/209"/>
                            </div>
                            <div class="info-text">
                                <p class="text"><span class="name">Bertier Clément</span> a mit a jour le post</p>
                            </div>
                            <div class="date">
                                <p>A l'instant</p>
                            </div>
                        </div>
                    
                    </div>

                    
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import store from '@/store/index.js';
    import { EventBus } from '@/event-bus';
    import ContextMenu from '@/components/dash/contextMenu/contextMenuInit.vue'
    import Phone from "./../../postCreator/components/Phone.vue"
    import RenderPostManager from '../../postCreator/components/standardTab/RenderPostManager.vue'
    import StoryMaker from '../../postCreator/components/storyTab/StoryMaker.vue'
    import postMixin from '@/components/mixins/Posts.vue'
    import draftMixin from '@/components/mixins/Drafts.vue'
    import postCreatorMixin from '../../postCreator/mixins/main.js'
    import postsMixin from '@/components/dash/posts/mixins/main.js'
    import { 
        mergeUpdates, 
        deepClone, 
    } from '../../postCreator/utils.js'
    import main from '../../postCreator/mixins/main.js';

    export default {
        mixins: [postMixin, draftMixin, postCreatorMixin, postsMixin],

        components: {
            ContextMenu,
            Phone,
            RenderPostManager,
            StoryMaker
        },
        props: {
            event: Object,
        },

        data() {
            return {
                
                models: {
                    commentValue: ''
                },
                comments : [],
                filesUploadComment: [],
                userAffected : [],


                sectionNavSelected: this.validationStatus !== null ? 'validation' : 'comments',
                expandedSectionNav: false,
                loading : {
                    sendComment: false,
                    setUserAffected: false,
                    validation: false
                },

                //Pour generateDataFormRequest
                dataFormRequest: {},
                tab: null,
                saveAllFormData: null,
                formData: null,
                idUsersAssigned: [],
                requiredValidation: false,
                files: {},

                //storyMaker
                indexStorySelected: 0
            }
        },

        mounted () {
            this.$refs.scrollContainer.addEventListener('wheel', this.handleScroll);
            this.sectionNavSelected = this.validationStatus !== null ? 'validation' : 'comments';
            this.setFormData()
        },
        
        methods: {
            resize() {
                const { textarea } = this.$refs;
                textarea.style.height = 0
                textarea.style.height = textarea.scrollHeight + 'px';
            },

            close() {
                this.$emit('close')
            },

            async setFormData(formData, verifyDynamicUrl = true) {
                console.log("setFormData", formData, this.event && this.event.draft && this.event.draft.saveAllFormData)
                if (!formData) {
                    if (!this.event.draft.saveAllFormData) return null
                    formData = this.event.draft.saveAllFormData
                }
               
                let formDataRef = deepClone(formData.main)
            
                if (formData.networks[this.event.page.network]) mergeUpdates(formDataRef, formData.networks[this.event.page.network])
                if (formData.pages[this.event.page.id]) mergeUpdates(formDataRef, formData.pages[this.event.page.id])
            
                this.formData = formDataRef

                //mettre a jours les liens invalide
                if (verifyDynamicUrl) {
                    const {saveAllFormData, isModified} = await this.verifyDynamicUrlInstagram(this.event.draft.saveAllFormData, this.event.page.id)
                    if (isModified)  this.setFormData(saveAllFormData, false)           
                }
                
              
            },

           

            editPost() {

                if (this.officialStatus == 'scheduled') {

                    let posts 
                    if (this.event.originalPost.page[0].posts_multipages && this.event.originalPost.page[0].posts_multipages.length) {
                        posts = this.event.originalPost.page[0].posts_multipages
                    }else{
                        posts = [{
                            _id: this.event.originalPost.id,
                            id: this.event.originalPost.id,
                            bot: this.event.originalPost._bots[0].id,
                            page: this.event.originalPost._bots[0].page.id,
                            postId: this.event.originalPost.page[0].post_number,
                            status: this.event.originalPost.status,
                        }]
                    }

                    this.$store.commit('postCreator/setDataForEditPost', {
                        draft: this.event.draft,
                        posts,
                        post: this.event.originalPost

                    });
                    this.$router.push('/dash/postCreator/edit');
                }else if(this.officialStatus == 'draft') {
                    this.$store.commit('postCreator/setDataForDraft', {
                        data: this.event.draft,
                        id : this.event.originalPost.id
                    });
                    this.$router.push('/dash/postCreator/draft');
                }
            },                                                                                      

            duplicatePost() {
                let pages
                if ( this.event.originalPost.page[0].posts_multipages && this.event.originalPost.page[0].posts_multipages.length) {
                    pages = this.event.originalPost.page[0].posts_multipages.map(post => post.page) 
                }else{
                    pages = [this.event.originalPost._bots[0].page.id]
                }
     
                this.$store.commit('postCreator/setDataForDuplicatePost', {
                    draft: this.event.draft,
                    pages
                });
                this.$router.push('/dash/postCreator/duplicate');
            },

            deletePost() {

                EventBus.$emit("showModal", 
                    "Supprimer le post", 
                    "Etes vous certain de vouloir supprimer ce post ?",
                    "Supprimer",  
                    "Anuler", 
                    ()=>{
                        this.$emit('deletePost')
                      
                    }
                );
               
            },

            clickOption(contextMenuId, nameOption, event) {
           
                switch (nameOption) {
                    case 'copyLink':
                        const baseUrl = window.location.origin;
                        const paramsLink = {
                            post_id: this.event.originalPost.id,
                            page_id: this.event.page.id,
                            bot_id: this.event.originalPost._bots[0].id,
                            is_draft: this.officialStatus === 'draft'
                        };

                        const queryString = new URLSearchParams(paramsLink).toString();
                        const link = `${baseUrl}/#/dash/posts2?${queryString}`;

                        navigator.clipboard.writeText(link).then(() => {
                            this.$vs.notify({
                                title: this.$t('dash.posts.success'),
                                text: this.$t('dash.settings.user.viewer_url.copy'),
                                color:'success'
                            })
                           
                        }, (err) => {
                            console.error('Error copying text: ', err);
                        });
                        break;
                    default:
                        break;
                }
            },

            dateFormat(dateFormat) {
     
                if (typeof dateFormat !== "object") {
                    dateFormat = new Date(dateFormat)
                }
                let date = new Date()
                let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

                if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateFormat.getDate().toString() + dateFormat.getMonth().toString() + dateFormat.getFullYear().toString())){
                    return "Aujourd'hui à "+dateFormat.getHours()+":"+(dateFormat.getMinutes()<10?'0':'') + dateFormat.getMinutes() ;
                    
                }else if((date.getFullYear() == dateFormat.getFullYear()) && (date.getMonth() == dateFormat.getMonth()) && dateFormat.getDate() == (date.getDate() - 1)){
                    return "Hier à "+dateFormat.getHours()+":"+(dateFormat.getMinutes()<10?'0':'') + dateFormat.getMinutes() ;
                }else{
                    return "Le "+dateFormat.getDate()+" "+tab_Month[dateFormat.getMonth()]+" "+dateFormat.getFullYear()+" à "+dateFormat.getHours()+":"+(dateFormat.getMinutes()<10?'0':'') + dateFormat.getMinutes()  ;
                }
            },

            buildComment() {
        
                if (this.event.originalPost.page.length && this.event.originalPost.page[0].comments && this.event.originalPost.page[0].comments.length) {
                    this.comments = this.event.originalPost.page[0].comments.map((comment) => ({
                        ...comment,
                        dateFormat : this.dateFormat(comment.date),
                        avatar:  this.usersSortByEmail[comment.email] ? this.usersSortByEmail[comment.email].avatar : null,
                        ...(comment.email == this.currentUser.email ? {name : 'Vous'} : {})
                    })).reverse()
                }else{
                    this.comments = []
                }
            },

            buildAssignment() {
                this.userAffected = []
                if (this.event.originalPost.page.length && this.event.originalPost.page[0].affectedTo) {
                    if (this.event.originalPost.page[0].affectedTo.users	&& this.event.originalPost.page[0].affectedTo.users.length) {
                        this.userAffected = this.event.originalPost.page[0].affectedTo.users
                    }else if(this.event.originalPost.page[0].affectedTo.user){
                        this.userAffected = [this.event.originalPost.page[0].affectedTo.user]
                    }
                }
                this.userAffected = this.userAffected.map((user) => ({
                    ...user,
                    ...(this.$store.getters['users/getUsers'][user.id] || {}),
                }))
            },

            handleScroll(event) {
                this.expandedSectionNav = true
                // if (event.deltaY > 0) {
                //     this.expandedSectionNav = true
                // }
            },

            selectFilesComment(e) {
                const files = Array.from(e.target.files);
                this.filesUploadComment = files.map((file, index) => {

                    return {
                        url: URL.createObjectURL(file),
                        type: file.type
                    }
                })
            },

            async newComment(all=null) {
                if (this.loading.sendComment) return

                if (all == null) {
                    if (this.isPostsMultipaged(this.event.originalPost)) {
                        EventBus.$emit("showModal", 
                            "Ajout de notes", 
                            "Ce post a été poussé sur plusieurs pages. Souhaitez-vous ajouter la note à l'ensemble des posts ? ", 
                            "Tout les posts", 
                            "Ce post uniquement",  
                            ()=>{
                                this.newComment(true)
                            },
                            ()=>{
                                this.newComment(false)
                            },
                        );
                        return
                    }else{
                        all = false
                    }
                }
            
                this.$set(this.loading, 'sendComment', true)
                let mediasUpload = []

                for (const file of this.filesUploadComment) {
                    const {file_url} = await this.uploadFile(file.url);
                    mediasUpload.push({
                        url: file_url,
                        type: file.type
                    })
                    console.log("newComment res", file_url)
                }

                const comment = {   
                    date: new Date().toISOString(),
                    message: this.models.commentValue,
                    name: !localStorage.supervisor ? `${this.currentUser.lastname} ${this.currentUser.firstname}` : 'Mashup Web Social',
                    email: !localStorage.supervisor ? this.currentUser.email : 'contact@mashup-web.com',
                    mediasUpload: mediasUpload
                }
                console.log("newComment", comment,  this.event.originalPost, all)
                try {
                    const {body} = await this.addCommentPost(
                        this.event.originalPost,
                        comment,
                        all
                    )
                    if (body.success) {
                        this.filesUploadComment = []
                        this.$set(this.models, 'commentValue', '')
                        this.$set(this.event, 'originalPost', {...this.event.originalPost, ...body.post})
                        this.buildComment()
                    }
                } catch (error) {
                    console.error(error)
                }
                this.$set(this.loading, 'sendComment', false)
            },
            
            async uploadFile(file) {
                const { VUE_APP_API_HOST } = process.env 

                if (typeof file === "string" && file.startsWith("blob:")) {
                    const response = await fetch(file);
                    const blob = await response.blob();
                    file = new File([blob], "uploaded-file", { type: blob.type });
                }

                let formData = new FormData()
                formData.append('file', file)

                try {
                    const  { body } = await this.$http.post(`${VUE_APP_API_HOST}/posts/upload/file`, formData)
                    return body
                } catch (error) {
                    
                }
            },

            async removeUserAffected(userId) {
                this.userAffected = this.userAffected.filter(user => user.id !== userId)
                const idUsersSelected = this.userAffected.map(user => user.id)
                const data = {
                    page: this.event.originalPost._bots[0].page.id, 
                    bot: this.event.originalPost._bots[0].id, 
                    post: this.event.originalPost.id, 
                    status: this.event.originalPost.status
                }

                if (idUsersSelected.length) {
                    data.user= idUsersSelected[0]
                    data.users= idUsersSelected
                }
                console.log("affectedUserToPost", data)
                await this.affectedUserToPost(data)
            },

            async validatePost(all=null) {
                if (this.loading.validation) return

                let countPage = 1
                if (this.officialStatus == "draft")  countPage = this.event.draft.pages.length 
                else if (this.event.originalPost.page[0].posts_multipages) countPage = this.event.originalPost.page[0].posts_multipages.length 
  
        
                if (all == null) {
                 
                    if (countPage > 1) {
                        EventBus.$emit("showModal", 
                            "Ajout de notes", 
                            "Ce post a été poussé sur plusieurs pages. Souhaitez-vous ajouter la note à l'ensemble des posts ? ", 
                            "Tout les posts", 
                            "Ce post uniquement",  
                            ()=>{
                                this.validatePost(true)
                            },
                            ()=>{
                                this.validatePost(false)
                            },
                        );
                        return
                    }else{
                        all = false
                    }
                }
            
                this.$set(this.loading, 'validation', true)
                switch (this.officialStatus) {
                    case "scheduled":
                        await this.validateSchedulePost(all)
                        this.$set(this.loading, 'validation', false)
                        break;
                    case "draft":
                        setTimeout(() => {
                            EventBus.$emit("showModal", 
                                this.$t(`dash.posts.multi-pages.validate_draft_to_post${countPage > 1 ? 's' : ''}.title`),
                                this.$t(`dash.posts.multi-pages.validate_draft_to_post${countPage > 1 ? 's' : ''}.body`), 
                                "Continuer",  
                                this.$t('dash.button.cancel'), 
                                async ()=>{
                                    await this.validateDraft(all)
                                    this.$set(this.loading, 'validation', false)
                                }
                            )
                        }, 200);
                   
                        break;
                }

                
            },

            async validateSchedulePost(all) {
                const res = await this.validateWaitingPost(this.event.originalPost, {
                    name: `${this.currentUser.firstname} ${this.currentUser.lastname}`, 
                    email: this.currentUser.email,
                    date: new Date().toISOString()
                }, all)
                
                this.$set(this.event, 'originalPost', {...this.event.originalPost, ...res.body.post })
            },

            async validateDraft(all) {
                this.tab = this.event.draft.tab && this.event.draft.tab !== 'standard' ? 'story' : 'standard'
                this.saveAllFormData = this.event.draft.saveAllFormData
                this.idUsersAssigned = this.event.draft.idUsersAssigned
                this.requiredValidation = false
                this.files = this.event.draft.files

                let pagesSelected = [this.allPages[this.event.page.id]]
                
                if (all) {
                    pagesSelected = this.event.draft.pages.reduce((acc, page) => {
                        if (this.allPages[page]) acc.push(this.allPages[page])
                        return acc
                    }, [])
                }
                
                if (this.tab == 'story') {
                    pagesSelected = pagesSelected.filter(page => page.network == 'instagram')
                }
                
                this.generateDataFormRequest((dataFormRequest) => {
                    console.log("validateDraft", "dataFormRequest", dataFormRequest)
                    const requestGroup = []
                    for (const [pageId, formData] of Object.entries(dataFormRequest)) {
                        if (!formData.hasOwnProperty('error')) {
                            const page = this.allPages[pageId]                    
                            requestGroup.push({
                                start : async (onSuccess, onProgress, onError) => {
                                    try {
                                        this.$store.commit('planner/addNewStaticEvent', {
                                            eventId: this.event.originalPost.id + page.id,
                                           
                                            event: {
                                                content: formData["data[title]"],
                                                date: formData["data[scheduled_date]"] || new Date().toISOString(),
                                                id: this.event.originalPost.id + page.id,
                                                image: formData["data[enclosure]"],
                                                page: page,
                                                loading: true,
                                                status: formData["data[scheduled_date]"] ? 'scheduled' : 'posted',
                                            }
                                        });
                    
                                        const response = await this.new({
                                            ...formData,
                                            "data[removeDraft]": this.event.originalPost.id
                                        });

                                        this.$store.commit('planner/removeStaticEvent', this.event.originalPost.id + page.id)
                                         
                                        if (response.data.success) {
                                            onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                            EventBus.$emit('planner/refresh', 0)
                                            return {response, formData: { ...formData, pageId }}
                                        }else{
                                            throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                        }
                                    } catch (error) {
                                        onError(error.message);
                                        return {response:null, formData: { ...formData, pageId }}
                                    }
                                },
                                params : {
                                    picture : formData["data[enclosure]"] || page.avatar,
                                    title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                    loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                }
                            });
                        }else{
                            this.$vs.notify({
                                title: "Impossible de valider le post",
                                text: "Les informations d'un des posts sont incomplètes, veuillez planifier manuellement.",
                                color:'success'
                            })
                            return
                        }
                    }

                    EventBus.$emit('requestManagerAddGroup',requestGroup, async(responses)=> {
                        try {
                            const posts = responses.filter(({response}) => response.data.success && response.data.news && response.data.post && response.data.post.success).map(({response, formData}) => ({
                                _id: response.data.news._id,
                                bot: formData.bot,
                                page: formData.pageId,
                                postId: response.data.post.post,
                                status: 1,
                                story: null,
                            }))
                            console.log("requestManagerAddGroup", posts)
                            if (posts.length > 1) {
                                const res = await this.updatePostsMultiPages(posts)
                            }
                            console.log("requestManagerAddGroup", responses.length , posts.length)
                            if(responses.length == posts.length) {
                                try {
                                    console.log("requestManagerAddGroup", this.event.originalPost.id)
                                    this.deleteDraft(this.event.originalPost.id)
                                } catch (error) {
                                    console.error("Echec de la supression du draft")
                                }
                            }
                        
                        } catch (error) {
                            console.error(error.message)
                        }
                    })     

                }, pagesSelected,  false, false)
            },

            async removeValidationPost() {
                if (this.loading.validation) return
                this.$set(this.loading, 'validation', true)
                const res = await this.removeValidateWaitingPost(this.event.originalPost)
                console.log("removeValidationPost", res)
                this.$set(this.event, 'originalPost', {...this.event.originalPost, ...res.body.post })
                this.$set(this.loading, 'validation', false)
           
            },

            setUsersAffected() {
                if (this.loading.setUserAffected) return
                this.$set(this.loading , "setUserAffected", true)

                const defaultSelection = this.userAffected.map(user => user.id)
                EventBus.$emit('selectUsers',async (idUsersSelected)=>{
                    if (defaultSelection.length != idUsersSelected.length || idUsersSelected.some(id => !defaultSelection.includes(id))) {
                        this.userAffected = idUsersSelected.map(userId => this.$store.getters['users/getUsers'][userId])
                        const data = {
                            page: this.event.originalPost._bots[0].page.id, 
                            bot: this.event.originalPost._bots[0].id, 
                            post: this.event.originalPost.id, 
                            status: this.event.originalPost.status
                        }

                        if (idUsersSelected.length) {
                            data.user= idUsersSelected[0]
                            data.users= idUsersSelected
                        }
                        console.log("affectedUserToPost", data)
                        await this.affectedUserToPost(data)
                    }


                    this.$set(this.loading, "setUserAffected", false)
                  
                },{
                    defaultSelection,
                    subTitle: 'Les utilisateurs recevront une demande de validation.'
                },()=> {
                        this.$set(this.loading , "setUserAffected", false)
                })
               
            },
        },

        watch: {
            post: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.buildComment()
                    this.buildAssignment()
                }
            },
            ["event.draft.saveAllFormData"]: {
                handler() {
                    this.setFormData()
                },
                immediate: true
            },
        },
        

        computed: {
            officialStatus() {
                return ['removed', null, 'scheduled', 'posted', 'pending', 'failed', null, 'draft'][this.event.originalPost.page[0].status + 1] //+1 pour inclure removed (removed = -1) 
            },
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            usersSortByEmail() {
                return Object.fromEntries(
                    Object.entries(this.$store.getters['users/getUsers']).map(([key, value]) => [value.email, value])
                );
            },
            currentUser() {
                return this.$store.getters['users/getCurrentUser']
            },

            validationStatus() {
                //return null if not option actived or current user not affected
                //return false if post not validated
                //return true if post validated

                if (
                    ['draft', 'scheduled'].includes(this.officialStatus) && 
                    this.event.originalPost.page[0].affectedTo &&
                    this.event.originalPost.page[0].affectedTo.optionValidation &&
                    this.event.originalPost.page[0].affectedTo.optionValidation !== "false" &&
                    (
                        (this.event.originalPost.page[0].affectedTo.user && this.event.originalPost.page[0].affectedTo.user.id  == this.currentUser.id) ||
                        (this.event.originalPost.page[0].affectedTo.users && this.event.originalPost.page[0].affectedTo.users.some(user => user.id == this.currentUser.id))
                    )

                ) {
                    // option validation actived
                    return ("wait_validation" in this.event.originalPost.page[0] && this.event.originalPost.page[0].wait_validation !== null && this.event.originalPost.page[0].wait_validation !== 'null')

                }


                return null

            },
        },

        beforeDestroy() {
            this.$refs.scrollContainer.removeEventListener('wheel', this.handleScroll);
        },
        
    }
</script>